import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import {
    suppliesCategoryListRequest, addSuppliesCategoryRequest, addSuppliesCategoryRequestStatus,
    updateSuppliesCategoryDetailRequest, updateSuppliesCategoryDetailRequestStatus
} from '../../../redux/supplies/supplies.action'
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import { use } from "react";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";

const SuppliesCatList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { suppliesCategoryListSuccess, suppliesCategoryListError } = useSelector(state => state.supplies)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.SUPPLIES_ITEM_CAT_LIST, true)
            fetchBusinessList()
        } else if (isLoggedInUserEmployee(user)) {
            fetchCategoriesList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.SUPPLIES_ITEM_CAT_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.SUPPLIES_ITEM_CAT_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(suppliesCategoryListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(suppliesCategoryListError)) {
            setLoading(false)
        }
    }, [suppliesCategoryListSuccess, suppliesCategoryListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchCategoriesList()
        }
    }, [selectedLocation])

    const fetchCategoriesList = () => {
        setLoading(true)
        const data = {
            businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
            locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
        }
        dispatch(suppliesCategoryListRequest(data))
    }

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.SUPPLIES.ADD_CATEGORY) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.SUPPLIES, PERMISSION_SUB_TYPE.SUPPLIES.ADD_CATEGORY, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }

    const handleAddCategoryClick = () => {
        navigate(ROUTES.supplies.category.list)
    }

    const handleDetailClick = (item) => {
        navigate(ROUTES.supplies.item.list, {
            state: {
                suppliesCategoryId: item.suppliesCategoryId,
                categoryName: item.name,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
            }
        })
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Select Category' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                {!isNull(suppliesCategoryListSuccess) && !isEmpty(suppliesCategoryListSuccess.data) && <div className="pms-option-list-container">
                    {suppliesCategoryListSuccess.data.map(item => (<div className="pms-ol-item-container" onClick={() => { handleDetailClick(item) }}>
                        <h5 className="pms-oli-label">{item.name}</h5>
                        <div className="pms-oli-img-container">
                            <img src={require('../../../assets/ic_right_icon.png')} className="img" alt="img" />
                        </div>
                    </div>))}
                </div>}
                {!isEmpty(suppliesCategoryListError) && <div className="content-error">{suppliesCategoryListError.message}</div>}
                {isPermissionAllowed(PERMISSION_SUB_TYPE.SUPPLIES.ADD_CATEGORY) && <div className="vl-fab-container" onClick={() => handleAddCategoryClick()}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default SuppliesCatList